import React from "react";
import { cn } from "@/lib/utils";

export default function StatCard({ label, value, hint, icon: Icon, trend, accent, className, "data-testid": testId }) {
  return (
    <div
      data-testid={testId || "stat-card"}
      className={cn(
        "axia-card p-5 flex flex-col justify-between min-h-[120px] hover:border-slate-300 transition-colors",
        className
      )}
    >
      <div className="flex items-start justify-between">
        <div className="axia-overline">{label}</div>
        {Icon && (
          <div className={cn("w-7 h-7 rounded-md flex items-center justify-center", accent || "bg-slate-100 text-slate-600")}>
            <Icon className="w-3.5 h-3.5" />
          </div>
        )}
      </div>
      <div className="mt-3">
        <div className="font-display text-3xl font-bold tracking-tight text-slate-900">{value}</div>
        {hint && <div className="text-xs text-slate-500 mt-1.5">{hint}</div>}
        {trend && (
          <div className={cn("text-xs font-medium mt-1.5", trend.positive ? "text-emerald-600" : "text-rose-600")}>
            {trend.label}
          </div>
        )}
      </div>
    </div>
  );
}
